import axios from 'axios';
import { APIENDPOINTS } from './ApiEndPoints/ApiEndpoints';
import { RefreshToken } from './APIConfig';

const baseURL = ['development', 'staging', 'production'].includes(process.env.REACT_APP_ENV)
  ? `${window.location.origin}/api`
  : 'https://dev.esign-proteantech.in/api';

const AxiosInstance = axios.create({ baseURL });

export default AxiosInstance;

AxiosInstance.interceptors.request.use(req => {
  const token = localStorage.getItem('authToken');
  if (location.hostname == 'localhost' && localStorage.getItem('esign_local')) {
    const baseUrl = req.baseURL;
    const actionUrl = req.url;
    let updatedBaseUrl = 'http://' + location.hostname + ':';

    const projectName = actionUrl.split('/')[1];
    if (projectName == 'iam') {
      updatedBaseUrl = updatedBaseUrl + '5001/api';
    } else if (projectName == 'esign') {
      updatedBaseUrl = updatedBaseUrl + '5000/api';
    } else if (projectName == 'report') {
      updatedBaseUrl = updatedBaseUrl + '5004/api';
    } else if (projectName == 'wfms') {
      updatedBaseUrl = updatedBaseUrl + '5002/api';
    } else {
      updatedBaseUrl = baseUrl;
    }

    req.baseURL = updatedBaseUrl;
  }

  if (token) {
    req.headers['Authorization'] = `Bearer ${token}`;
  }
  return req;
});

AxiosInstance.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response.data;
  },
 async err => {
   // Any status codes that falls outside the range of 2xx cause this function to trigger
		const status = err.response?.status || 500;
		const errorMessage = err.response.data.message === 'User is not active';
		const isRefreshApiCall
			= err.config?.url === APIENDPOINTS.LOGIN.refreshToken;
		const isLogoutApi = err.config?.url === APIENDPOINTS.LOGIN.logout;
		// We can handle global errors here
		switch (status) {
		// Authentication (token related issues)
		case 401: {
			window.localStorage.removeItem('authToken');

			if (isLogoutApi || errorMessage) {
				window.localStorage.removeItem('refreshToken');
        window.localStorage.removeItem('authToken_expiration');
				window.location.href = '/login';
				return err?.response?.data;
			}

			const refreshToken = window.localStorage.getItem('refreshToken');
			if (refreshToken && !isRefreshApiCall) {
				const originalRequest = err.config;

				// Initialize retry count if not already set
				originalRequest._retryCount ||= 0;

				// If retry count exceeds limit, logout
				if (originalRequest._retryCount >= 5) {
					console.error('Maximum retry limit reached. Logging out.');
					window.localStorage.removeItem('refreshToken');
          localStorage.removeItem('authToken_expiration');
					window.location.href = '/login';
					return err?.response?.data;
				}

				originalRequest._retryCount += 1;

				try {
					const response = await RefreshToken({ refreshToken });
					if (response.status === 201) {
						const newAccessToken = response?.token;
						const newRefreshToken = response?.refreshToken;
						window.localStorage.setItem('authToken', newAccessToken);
						window.localStorage.setItem('refreshToken', newRefreshToken);

						// Update the original request with new token
						originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
						return AxiosInstance(originalRequest);
					}
          window.localStorage.removeItem('authToken_expiration');
					window.localStorage.removeItem('refreshToken');
					window.location.href = '/login';
					return err?.response?.data;
				} catch {
					window.localStorage.removeItem('refreshToken');
					window.location.href = '/login';
					return err?.response?.data;
				}
			}

			return err?.response?.data;
		}

      // forbidden (permission related issues)
      case 403: {
        // window.location.href = '/login';
        console.error('403 ', err?.response?.data?.message);
        return err?.response?.data;
      }

      // bad request
      case 400: {
        console.error('400 ', err?.response?.data?.message);
        return err?.response?.data;
      }

      // not found
      case 404: {
        console.error('404 ', err?.response?.data?.message);
        return err?.response?.data;
      }

      // conflict
      case 409: {
        console.error('409 ', err?.response?.data?.message);
        return err?.response?.data;
      }

      // unprocessable
      case 422: {
        console.error('422 ', err?.response?.data?.message);
        return err?.response?.data;
      }

      // generic api error (server related) unexpected
      default: {
        console.error(err?.response?.status + ' ', err?.response?.data?.message);
        return err?.response?.data;
      }
    }
  }
);
